<script>
export default {
    name: "AuditingDashBoard",
}
</script>
<style scoped>
@import  '~vue-context/dist/css/vue-context.css';
</style>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <div class="flex flex-wrap">
                <div class="w-full p-1 my-1 text-center text-white bg-blue-500 rounded">
                    <h5 class="font-medium text-lg uppercase">Auditing DashBoard</h5>
                </div>
                <router-link :to="{name:`auditing.consultant-related-services.index`}" 
                    class="w-full md:w-1/3 xl:w-1/3 p-2 md:my-0 my-2">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-green-600"><i class="fas fa-users fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Consultant Related Services</h5>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:`auditing.inpatient.index`}" 
                    class="w-full md:w-1/3 xl:w-1/3 p-2 md:my-0 my-2">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600">
                                    <i class="fas fa-procedures fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Inpatient</h5>
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{name:`auditing.morgue.index`}" 
                    class="w-full md:w-1/3 xl:w-1/3 p-2 md:my-0 my-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-indigo-600">
                                    <i class="fas fa-bed fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Morgue</h5>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
        </template>
    </tail-base-layout>
</template>